import type { ContainerItemOption, ContainerItemSchemaSetting } from 'libs/shared/src';

/**
 * Possible view-templates for container-gallery
 * @readonly This gets generated from the template.config.json // DO NOT MODIFY HERE!
 */
export type ContainerViewTemplateName = 'petalslider' | 'imageteaser' | 'titleslider' | 'box' | 'grid' | 'slider';

/**
 * Settings metadata for a container-gallery view-template.
 * @description A component-class-free copy of the VIEW_TEMPLATES registry. Schemas import this
 * (instead of view-templates.ts) so the Angular component classes are never pulled into a
 * circular import.
 */
export interface IContainerViewTemplateSetting {
  /** Name of the view-template */
  name: ContainerViewTemplateName;
  /** Supported options in the backend */
  supportedOptions: ContainerItemOption[];
  /** Supported settings in the schema of the container-gallery */
  supportedSettings?: ContainerItemSchemaSetting[];
}

/**
 * Available view-template settings for the container-gallery component
 * @readonly These settings are generated from the template.config.json // DO NOT MODIFY HERE!
 */
export const VIEW_TEMPLATE_SETTINGS: IContainerViewTemplateSetting[] = [
  {
    name: 'petalslider',
    supportedOptions: ['Name', 'Pages', 'Videos', 'Description', 'Picture', 'ExternalUrl', 'Articles', 'Validate'],
    supportedSettings: ['galleryHeight', 'sliderOptions', 'sliderColumns', 'sliderSpaceBetween', 'sliderNavigationType', 'showItemSubtitle', 'shortenItemTitles']
  },
  {
    name: 'imageteaser',
    supportedOptions: ['Name', 'Pages', 'Videos', 'Description', 'Picture', 'ExternalUrl', 'Articles', 'News', 'Reports', 'Categories', 'TeamMembers', 'CalendarItems', 'Leaflets', 'Validate'],
    supportedSettings: ['galleryHeight', 'imageOverlayColor', 'imageBorder', 'showItemSubtitle', 'shortenItemTitles']
  },
  {
    name: 'titleslider',
    supportedOptions: ['Name', 'Pages', 'Videos', 'Description', 'Picture', 'ExternalUrl', 'Articles', 'Validate'],
    supportedSettings: ['galleryHeight', 'textShadow', 'textBackground', 'textBackgroundColor', 'imageOverlay', 'imageOverlayTransparency', 'imageOverlayColor', 'sliderOptions', 'sliderColumns', 'sliderSpaceBetween', 'sliderNavigationType', 'showItemSubtitle', 'shortenItemTitles', 'imageBorder']
  },
  {
    name: 'box',
    supportedOptions: ['Name', 'Pages', 'Videos', 'Description', 'Picture', 'ExternalUrl', 'Articles', 'Validate'],
    supportedSettings: ['textColor', 'textShadow', 'textBackground', 'textBackgroundColor', 'imageOverlay', 'imageOverlayTransparency', 'imageOverlayColor', 'itemPadding', 'elements', 'verticalAlignment', 'boxSpaceBetween', 'showItemSubtitle', 'shortenItemTitles', 'imageBorder']
  },
  {
    name: 'grid',
    supportedOptions: ['Categories', 'Reports', 'TeamMembers', 'CalendarItems', 'Pages', 'Videos', 'News', 'Leaflets', 'Articles'],
    supportedSettings: ['boxSpaceBetween', 'itemPadding', 'elements', 'itemTeaser', 'quickBuy', 'hover', 'imageBorder', 'showItemSubtitle', 'shortenItemTitles']
  },
  {
    name: 'slider',
    supportedOptions: ['Categories', 'Reports', 'TeamMembers', 'CalendarItems', 'Pages', 'Videos', 'News', 'Leaflets', 'Articles'],
    supportedSettings: ['itemPadding', 'elements', 'itemTeaser', 'quickBuy', 'sliderOptions', 'sliderColumns', 'sliderSpaceBetween', 'sliderNavigationType', 'hover', 'imageBorder', 'showItemSubtitle', 'shortenItemTitles']
  }
];
